import { Loading } from 'components/loading/Loading';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import React, { useEffect, useState } from 'react';
import DataTable from 'components/DataTable';
import { showError,showSuccess, useQueryParams } from 'utils';
import AddressDetails from './addressDetails';
import Header from './header';
import styles from './index.module.scss';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import { removeInventoryItemAddress } from 'services';


const ItemsPublicList = (props) => {
  const columns = [
    {
      name: 'Action',
      selector: '',
      sortable: false,
      width: '100px',
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className='d-flex flex-row'>
          <div className={'ml-3'}>
            <DeleteActionForTable
              onClick={() => removeInventoryItem(row)}
            />
          </div>
        </div>
      ),
    },
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <div>
          <CustomLink
            text={row.objectId}
            linkTo={`/inventory-items/${row.objectId}`}
          />
        </div>
      ),
    },
    {
      name: 'Item Name',
      selector: 'name',
      sortable: false,
      width: '400px',
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <div className={styles['item-name-and-image']}>
          <img src={row.image?.url} alt={row.name} />
          <div>{row.name || '-'}</div>
        </div>
      ),
    },
    {
      name: 'Category',
      selector: 'category.description',
      sortable: false,
    },
    {
      name: 'Unit',
      selector: 'unit',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: (row) => <div>{row.unit?.description || ''}</div>,
    },
    {
      name: 'Stock',
      selector: 'stock',
      sortable: false,
    },
    {
      name: 'Unfulfilled Stock',
      selector: 'unfulfilledStock',
      sortable: false,
      format: (row) => (row.unfulfilledStock ? row.unfulfilledStock : '0'),
    },
  ];
  
  
  const [data, setData] = useState<Record<string, any>[]>([]);
  const [filterText, setFilterText] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [addressObj, setAddressObj] = useState({});
  const query = useQueryParams();

  const convertInventoryAddresStringToObject = (addressString) => {
    return {
      storageSection: addressString[0],
      furnitureNo: parseInt(addressString.slice(1, addressString.indexOf('.'))),
      shelfNo: parseInt(addressString.slice(addressString.indexOf('.') + 1)),
    };
  };

  const fetchItemsList = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_ROOT_URL}/public/inventory${props.location.search}`,
      );
      setData(await response.json());
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const removeInventoryItem = async (item) => {
   
    setLoading(true);
    const data = { 
      id: item.objectId,
      probability: 2,
      startInventoryAddress: undefined,
      endInventoryAddress: undefined,
    };
    
    try {
      await removeInventoryItemAddress(data);
      await fetchItemsList();
      showSuccess('Item removed successfully');
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const addressString = query.get('inventoryAddress');
    setAddressObj(convertInventoryAddresStringToObject(addressString));
    fetchItemsList();
  }, []);

  const getTableData = () =>
    data.filter((item) =>
      item.name.toLowerCase().includes(filterText.toLowerCase()),
    );

  return (
    <div className={styles['main-container']}>
      {loading && <Loading />}
      <Header addressObj={addressObj} fetchItemsList={fetchItemsList} />
      <AddressDetails addressObj={addressObj} />
      <DataTable
        columns={columns}
        data={getTableData()}
        customStyles={tableStyles}
      />
    </div>
  );
};

export default ItemsPublicList;
